(function() {
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(value) {
    var parsed = Number(value);

    if (Number.isNaN(parsed)) {
      return value || '0.00';
    }

    return parsed.toFixed(2);
  }

  function parseMoney(value) {
    var parsed = Number(value);

    if (Number.isNaN(parsed)) {
      return 0;
    }

    return parsed;
  }

  function formatCurrency(value, currencyCode) {
    var amount = parseMoney(value);

    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode || 'GBP'
      }).format(amount);
    } catch (_error) {
      return (currencyCode || 'GBP') + ' ' + formatMoney(amount);
    }
  }

  function normalizeWorkerUrl(rawUrl) {
    return String(rawUrl || '').replace(/\/$/, '');
  }

  function formatTemplate(template, replacements) {
    if (!template) {
      return '';
    }

    return String(template).replace(/\[([^\]]+)\]/g, function(_, token) {
      var value =
        replacements && Object.prototype.hasOwnProperty.call(replacements, token)
          ? replacements[token]
          : '';

      return value === null || value === undefined ? '' : String(value);
    });
  }

  function getConfigText(textConfig, key, fallback) {
    if (
      textConfig &&
      Object.prototype.hasOwnProperty.call(textConfig, key) &&
      textConfig[key] !== null &&
      textConfig[key] !== ''
    ) {
      return textConfig[key];
    }

    return fallback;
  }

  function getOrderIdTail(order) {
    if (!order || !order.id) {
      return '';
    }

    var parts = String(order.id).split('/');
    return parts[parts.length - 1] || '';
  }

  function getOrderDisplayName(order, textConfig) {
    if (order && order.name) {
      return order.name;
    }

    var idTail = getOrderIdTail(order);

    if (idTail) {
      var template = getConfigText(textConfig, 'draftOrderTitleWithIdText', 'Draft order [id]');
      return formatTemplate(template, { id: idTail });
    }

    return getConfigText(textConfig, 'draftOrderTitleText', 'Draft order');
  }

  function getOrderItemCount(order) {
    var totalQuantity = Number(order && order.totalQuantityOfLineItems);

    if (Number.isFinite(totalQuantity) && totalQuantity > 0) {
      return totalQuantity;
    }

    if (!order || !Array.isArray(order.lineItems)) {
      return 0;
    }

    return order.lineItems.reduce(function(total, item) {
      return total + (Number(item && item.quantity) || 0);
    }, 0);
  }

    function getOrderSummary(order, textConfig) {
    var itemCount = getOrderItemCount(order);
    var totalLabel = formatCurrency(order && order.totalPrice, order && order.currencyCode);

    if (!itemCount) {
      var emptyTemplate = getConfigText(
        textConfig,
        'orderSummaryEmptyText',
        'Ready to review and check out for [total].'
      );

      return formatTemplate(emptyTemplate, { total: totalLabel });
    }

    var itemLabel =
      itemCount === 1
        ? getConfigText(textConfig, 'itemQuantitySingularText', 'item')
        : getConfigText(textConfig, 'itemQuantityPluralText', 'items');

    var summaryTemplate = getConfigText(
      textConfig,
      'orderSummaryWithItemsText',
      '[count] [item_label] in this live sale order · [total] total'
    );

    return formatTemplate(summaryTemplate, {
      count: String(itemCount),
      item_label: itemLabel,
      total: totalLabel
    });
  }

    function getItemMetaText(item, textConfig) {
    var parts = [];
    var variantTitle = String(item && item.variantTitle || '').trim();
    var quantity = Number(item && item.quantity) || 0;
    var quantityLabel =
      quantity === 1
        ? getConfigText(textConfig, 'itemQuantitySingularText', 'item')
        : getConfigText(textConfig, 'itemQuantityPluralText', 'items');
    var separator = getConfigText(textConfig, 'metaSeparatorText', ' · ');

    if (variantTitle && variantTitle !== 'Default Title' && variantTitle !== item.title) {
      parts.push(variantTitle);
    }

    if (quantity) {
      parts.push(quantity + ' ' + quantityLabel);
    }

    return parts.join(separator);
  }

  function getDraftOrderFlow() {
    return window.CrystalRarityDraftOrder || null;
  }

  function initializeSection($section, config) {
    if (!$section || !$section.length || $section.data('pending-order-search-initialized')) {
      return;
    }

    var emailInput = document.getElementById('pending-order-search-email-' + config.section_id);
    var searchButton = document.getElementById('pending-order-search-button-' + config.section_id);
    var loadingElement = document.getElementById('pending-order-search-loading-' + config.section_id);
    var messageElement = document.getElementById('pending-order-search-message-' + config.section_id);
    var resultElement = document.getElementById('pending-order-search-result-' + config.section_id);
    var merchElement = document.getElementById('pending-order-search-merch-' + config.section_id);
    var savedStateElement = document.getElementById('pending-order-search-saved-state-' + config.section_id);
    var savedCopyElement = document.getElementById('pending-order-search-saved-copy-' + config.section_id);
    var clearSavedButton = document.getElementById('pending-order-search-clear-saved-' + config.section_id);
    var orderTemplate = document.getElementById('pending-order-search-order-template-' + config.section_id);
    var lineItemTemplate = document.getElementById('pending-order-search-line-item-template-' + config.section_id);
    var draftOrderFlow = getDraftOrderFlow();
    var textConfig = config.text || {};
    var getTextValue = function(key, fallback) {
      return getConfigText(textConfig, key, fallback);
    };
    var recommendationsSection = document.getElementById('pending-order-search-recommendations-' + config.section_id);
    var recommendationsGrid = recommendationsSection
      ? recommendationsSection.querySelector('[data-pending-order-recommendations]')
      : null;
    var recommendationsPlaceholder = recommendationsSection
      ? recommendationsSection.querySelector('[data-recommendations-placeholder]')
      : null;
    var recommendationsSliderContainer = recommendationsSection
      ? recommendationsSection.querySelector('[data-pending-order-recommendations-slider]')
      : null;
    var routes = config.routes || {};

    if (!emailInput || !searchButton || !loadingElement || !messageElement || !resultElement || !orderTemplate || !lineItemTemplate) {
      return;
    }

    $section.data('pending-order-search-initialized', true);

    var existingContext = draftOrderFlow && draftOrderFlow.readContext ? draftOrderFlow.readContext() : null;
    var state = {
      currentEmail: '',
      currentOrders: [],
      activeDraftOrderId: existingContext && existingContext.draftOrderId ? existingContext.draftOrderId : '',
      searchRequestId: 0,
      isSearching: false,
      selectedExtras: [],
      isSubmittingCheckout: false,
      recommendationRequestId: 0,
      lastRecommendationsKey: '',
      recommendationMode: ''
    };

    function refreshLinkedCartInterfaces() {
      if (
        window.PXUTheme &&
        window.PXUTheme.jsAjaxCart &&
        typeof window.PXUTheme.jsAjaxCart.renderDraftOrderActions === 'function'
      ) {
        window.PXUTheme.jsAjaxCart.renderDraftOrderActions();
      }

      if (
        window.PXUTheme &&
        window.PXUTheme.jsCart &&
        typeof window.PXUTheme.jsCart.renderDraftOrderActions === 'function'
      ) {
        window.PXUTheme.jsCart.renderDraftOrderActions();
      }
    }

    function openCartForActiveOrder() {
      var ajaxCart = window.PXUTheme && window.PXUTheme.jsAjaxCart ? window.PXUTheme.jsAjaxCart : null;
      var canOpenDrawer = ajaxCart && ajaxCart.cart_action === 'drawer' && typeof ajaxCart.showDrawer === 'function';
      var refresh;

      if (ajaxCart && typeof ajaxCart.updateView === 'function') {
        refresh = ajaxCart.updateView();
      }

      if (canOpenDrawer) {
        if (refresh && typeof refresh.always === 'function') {
          refresh.always(function() {
            ajaxCart.showDrawer();
          });
        } else {
          ajaxCart.showDrawer();
        }
        return;
      }

      if (!ajaxCart && window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) {
        window.location.href = window.PXUTheme.routes.cart_url;
      }
    }

    function clearSavedOrderState() {
      state.activeDraftOrderId = '';

      if (draftOrderFlow) {
        draftOrderFlow.clearContext();
      }

      if (savedStateElement) {
        savedStateElement.style.display = 'none';
      }

      if (state.currentOrders.length) {
        renderOrders();
      }
      resetRecommendations();
      refreshLinkedCartInterfaces();
    }

    function renderSavedOrderState(context) {
      if (!savedStateElement || !savedCopyElement) {
        return;
      }

      if (!context) {
        savedStateElement.style.display = 'none';
        savedCopyElement.textContent = '';
        return;
      }

      var savedTemplate = '[order_name] is active for [email]. This order is currently added to your cart!';
      savedCopyElement.textContent = formatTemplate(savedTemplate, {
        order_name: context.orderName || 'This live sale order',
        email: context.email || 'this customer'
      });
      savedStateElement.style.display = 'block';
    }

    function showRecommendationsPlaceholder(message) {
      if (!recommendationsSection || !recommendationsPlaceholder) {
        return;
      }
      recommendationsSection.style.display = '';
      if (recommendationsGrid) {
        recommendationsGrid.innerHTML = '';
        recommendationsGrid.style.display = 'none';
      }
      if (recommendationsSliderContainer) {
        recommendationsSliderContainer.innerHTML = '';
        recommendationsSliderContainer.style.display = 'none';
      }
      recommendationsPlaceholder.textContent = message;
      recommendationsPlaceholder.style.display = 'block';
    }

    function renderRecommendations(products, currencyCode) {
      if (!recommendationsSection || !recommendationsGrid) {
        return;
      }
      recommendationsSection.style.display = '';
      recommendationsGrid.innerHTML = '';
      if (recommendationsSliderContainer) {
        recommendationsSliderContainer.innerHTML = '';
        recommendationsSliderContainer.style.display = 'none';
      }
      recommendationsGrid.style.display = '';
      if (recommendationsPlaceholder) {
        recommendationsPlaceholder.style.display = 'none';
      }

      var displayCurrency = currencyCode || (state.currentOrders[0] && state.currentOrders[0].currencyCode) || 'USD';

      products.forEach(function(product) {
        var card = document.createElement('article');
        card.className = 'pending-order-search__recommendation-card';

        var link = document.createElement('a');
        link.className = 'pending-order-search__recommendation-link';
        var productHandle = product.handle;
        var productUrl = product.url || (productHandle ? '/products/' + productHandle : '#');

        if (productUrl && productUrl !== '#') {
          link.href = productUrl;
        } else {
          link.href = '#';
          link.setAttribute('aria-disabled', 'true');
          link.style.pointerEvents = 'none';
        }

        var imageSrc = (product.featured_image && product.featured_image.src) || (product.image && product.image.src);

        if (imageSrc) {
          var imageWrapper = document.createElement('div');
          imageWrapper.className = 'pending-order-search__recommendation-image';
          var img = document.createElement('img');
          img.src = imageSrc;
          img.alt = (product.featured_image && product.featured_image.alt) || product.title || '';
          imageWrapper.appendChild(img);
          link.appendChild(imageWrapper);
        }

        var title = document.createElement('p');
        title.className = 'pending-order-search__recommendation-title';
        title.textContent = product.title || '';
        link.appendChild(title);

        var priceValue = product.price || product.price_min || product.price_max || 0;
        var priceNode = document.createElement('p');
        priceNode.className = 'pending-order-search__recommendation-price';
        priceNode.textContent = formatCurrency(priceValue, displayCurrency);
        link.appendChild(priceNode);

        var compareValue = product.compare_at_price || product.compare_at_price_min;
        if (compareValue && parseFloat(compareValue) > parseFloat(priceValue || 0)) {
          var compareNode = document.createElement('p');
          compareNode.className = 'pending-order-search__recommendation-compare';
          compareNode.textContent = formatCurrency(compareValue, displayCurrency);
          link.appendChild(compareNode);
        }

        card.appendChild(link);
        recommendationsGrid.appendChild(card);
      });
    }

    async function loadRecommendationSlider(productId) {
      if (
        !recommendationsSection ||
        !recommendationsSliderContainer ||
        !(config.recommendations && config.recommendations.sectionId) ||
        !routes.productRecommendationsUrl
      ) {
        throw new Error('recommendations_slider_unavailable');
      }

      var sliderSectionId = config.recommendations.sectionId;
      var sliderLimit =
        (config.recommendations && Number(config.recommendations.limit)) ||
        4;
      var requestId = ++state.recommendationRequestId;
      showRecommendationsPlaceholder(
        getTextValue('recommendationsLoadingText', 'Loading recommended products...')
      );

      var requestUrl =
        routes.productRecommendationsUrl +
        (routes.productRecommendationsUrl.indexOf('?') >= 0 ? '&' : '?') +
        'section_id=' +
        encodeURIComponent(sliderSectionId) +
        '&limit=' +
        sliderLimit +
        '&product_id=' +
        encodeURIComponent(productId);

      var response = await fetch(requestUrl, { credentials: 'same-origin' });

      if (requestId !== state.recommendationRequestId) {
        return;
      }

      if (!response.ok) {
        throw new Error('recommendations_request_failed');
      }

      var html = await response.text();

      if (requestId !== state.recommendationRequestId) {
        return;
      }

      var container = document.createElement('div');
      container.innerHTML = html;
      var sliderMarkup = container.querySelector('.product-recommendations');
      if (!sliderMarkup) {
        throw new Error('recommendations_missing');
      }

      recommendationsSection.style.display = '';
      recommendationsSliderContainer.innerHTML = sliderMarkup.innerHTML;
      recommendationsSliderContainer.style.display = '';
      if (recommendationsPlaceholder) {
        recommendationsPlaceholder.style.display = 'none';
      }
      if (recommendationsGrid) {
        recommendationsGrid.style.display = 'none';
        recommendationsGrid.innerHTML = '';
      }

      if (
        window.PXUTheme &&
        window.PXUTheme.jsProduct &&
        window.PXUTheme.jsProduct.relatedProducts
      ) {
        window.PXUTheme.jsProduct.relatedProducts();
      }

      if (window.Shopify && window.Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.PXUTheme && window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    }

    async function loadRecommendationsForHandle(handle, currencyCode) {
      if (!handle || !recommendationsSection) {
        return;
      }

      var limit =
        (config.recommendations && Number(config.recommendations.limit)) ||
        4;
      var requestId = ++state.recommendationRequestId;
      showRecommendationsPlaceholder(
        getTextValue('recommendationsLoadingText', 'Loading recommended products...')
      );

      var origin =
        window.location.origin ||
        (window.location.protocol + '//' + window.location.host);
      var url =
        origin.replace(/\/$/, '') +
        '/products/' +
        encodeURIComponent(handle) +
        '/recommendations.json?limit=' +
        limit;

      try {
        var response = await fetch(url, { credentials: 'same-origin' });

        if (requestId !== state.recommendationRequestId) {
          return;
        }

        if (!response.ok) {
          throw new Error('recommendations_request_failed');
        }

        var data = await response.json();
        var products = Array.isArray(data.products) ? data.products : [];

        if (!products.length) {
          showRecommendationsPlaceholder(
            getTextValue(
              'recommendationsEmptyText',
              "We couldn't find any recommendations for this order yet."
            )
          );
          return;
        }

        renderRecommendations(products, currencyCode);
      } catch (_error) {
        if (requestId !== state.recommendationRequestId) {
          return;
        }

        showRecommendationsPlaceholder(
          getTextValue(
            'recommendationsErrorText',
            'Recommendations are unavailable at the moment.'
          )
        );
      }
    }

    function updateRecommendationsForOrder(order) {
      if (!recommendationsSection) {
        return;
      }

      if (!order || !Array.isArray(order.lineItems) || !order.lineItems.length) {
        showRecommendationsPlaceholder(
          getTextValue(
            'recommendationsPlaceholderText',
            'Search for a live sale order to preview related products.'
          )
        );
        return;
      }

      var candidate = order.lineItems.find(function(item) {
        return item.productHandle || item.productId;
      });

      if (!candidate) {
        showRecommendationsPlaceholder(
          getTextValue(
            'recommendationsEmptyText',
            "We couldn't find any recommendations for this order yet."
          )
        );
        return;
      }

      var handle = candidate.productHandle;
      var productId = candidate.productId;
      var sliderEnabled =
        Boolean(
          config.recommendations &&
            config.recommendations.useSlider &&
            config.recommendations.sectionId &&
            routes.productRecommendationsUrl &&
            productId
        );

      if (sliderEnabled) {
        if (state.lastRecommendationsKey === productId && state.recommendationMode === 'slider') {
          return;
        }
        state.lastRecommendationsKey = productId;
        state.recommendationMode = 'slider';

        loadRecommendationSlider(productId).catch(function() {
          state.lastRecommendationsKey = handle || '';
          state.recommendationMode = handle ? 'grid' : '';
          if (handle) {
            loadRecommendationsForHandle(handle, order.currencyCode);
          } else {
            showRecommendationsPlaceholder(
              getTextValue(
                'recommendationsEmptyText',
                "We couldn't find any recommendations for this order yet."
              )
            );
          }
        });

        return;
      }

      if (!handle) {
        showRecommendationsPlaceholder(
          getTextValue(
            'recommendationsEmptyText',
            "We couldn't find any recommendations for this order yet."
          )
        );
        return;
      }

      if (state.lastRecommendationsKey === handle && state.recommendationMode === 'grid') {
        return;
      }

      state.lastRecommendationsKey = handle;
      state.recommendationMode = 'grid';
      loadRecommendationsForHandle(handle, order.currencyCode);
    }

    function resetRecommendations() {
      if (!recommendationsSection || !recommendationsPlaceholder) {
        return;
      }

      state.recommendationRequestId += 1;
      state.lastRecommendationsKey = '';
      state.recommendationMode = '';
      showRecommendationsPlaceholder(
        getTextValue(
          'recommendationsPlaceholderText',
          'Search for a live sale order to preview related products.'
        )
      );
    }

    function saveCurrentOrderContext(primaryOrder) {
      if (!draftOrderFlow || !primaryOrder || !primaryOrder.id) {
        return;
      }

      state.activeDraftOrderId = primaryOrder.id;
      renderSavedOrderState(draftOrderFlow.saveContext({
        draftOrderId: primaryOrder.id,
        email: state.currentEmail,
        orderName: getOrderDisplayName(primaryOrder, textConfig),
        invoiceUrl: primaryOrder.invoiceUrl,
        totalPrice: primaryOrder.totalPrice,
        currencyCode: primaryOrder.currencyCode,
        workerUrl: config.workerUrl,
        workerSecret: config.workerSecret,
        searchPageUrl: window.location.pathname
      }));
      updateRecommendationsForOrder(primaryOrder);
      refreshLinkedCartInterfaces();
    }

    function setSearching(isSearching) {
      state.isSearching = isSearching;
      loadingElement.style.display = isSearching ? 'block' : 'none';
      searchButton.disabled = isSearching;
      searchButton.style.opacity = isSearching ? '0.7' : '1';
      searchButton.style.cursor = isSearching ? 'default' : 'pointer';
    }

    function clearMessage() {
      messageElement.style.display = 'none';
      messageElement.innerHTML = '';
    }

    function showMessage(kind, html) {
      var background = '#f8f9fa';
      var color = '#444';

      if (kind === 'error') {
        background = '#fee';
        color = '#c00';
      }

      if (kind === 'success') {
        background = '#e8f5e9';
        color = '#155724';
      }

      messageElement.style.display = 'block';
      messageElement.style.padding = '15px';
      messageElement.style.background = background;
      messageElement.style.color = color;
      messageElement.style.borderRadius = '8px';
      messageElement.style.textAlign = 'left';
      messageElement.innerHTML = html;
    }

    function clearResults() {
      resultElement.innerHTML = '';
    }

    function buildLineItemsFragment(order) {
      var lineItems = order && Array.isArray(order.lineItems) ? order.lineItems : [];
      var fragment = document.createDocumentFragment();

      if (!lineItems.length) {
        var emptyState = document.createElement('p');
        emptyState.style.margin = '0';
        emptyState.style.color = '#666';
        emptyState.textContent = getTextValue(
          'noLineItemsText',
          'No line items were returned for this order.'
        );
        fragment.appendChild(emptyState);
        return fragment;
      }

      var list = document.createElement('ul');
      list.className = 'pending-order-search__line-items-list';

      lineItems.forEach(function(item) {
        var itemNode = lineItemTemplate.content.firstElementChild.cloneNode(true);
        var itemLinkNode = itemNode.querySelector('[data-line-item-link]');
        var imageNode = itemNode.querySelector('[data-line-item-image]');
        var titleLinkNode = itemNode.querySelector('[data-line-item-title-link]');
        var metaNode = itemNode.querySelector('[data-line-item-meta]');
        var priceNode = itemNode.querySelector('[data-line-item-price]');
        var compareNode = itemNode.querySelector('[data-line-item-compare]');
        var totalNode = itemNode.querySelector('[data-line-item-total]');
        var legacyTextNode = itemNode.querySelector('[data-line-item-text]');
        var itemTitle = item.title || getTextValue('untitledItemText', 'Untitled item');
        var itemQuantity = Number(item.quantity) || 0;
        var itemPrice = formatCurrency(item.price, item.currencyCode || order.currencyCode);
        var itemTotal = formatCurrency(item.totalPrice, item.currencyCode || order.currencyCode);
        var compareAtPrice = parseMoney(item.compareAtPrice);
        var currentPrice = parseMoney(item.price);
        var productUrl = item.productUrl || '';

        if (titleLinkNode && metaNode && priceNode) {
          titleLinkNode.textContent = itemTitle;
          metaNode.textContent = getItemMetaText(item, textConfig);
          priceNode.textContent = itemPrice;
          totalNode.textContent = formatTemplate(getTextValue('lineTotalText', 'Total: [total]'), {
            total: itemTotal
          });
        } else if (legacyTextNode) {
          legacyTextNode.textContent = itemQuantity + 'x ' + itemTitle + ' - ' + itemPrice;
        }

        if (compareNode && compareAtPrice > currentPrice) {
          compareNode.style.display = 'inline';
          compareNode.textContent = formatCurrency(compareAtPrice, item.currencyCode || order.currencyCode);
        }

        if (imageNode && item.imageUrl) {
          imageNode.src = item.imageUrl;
          imageNode.alt = item.imageAlt || itemTitle;
          imageNode.style.display = 'block';
        } else if (itemLinkNode) {
          itemLinkNode.remove();
          itemLinkNode = null;
          itemNode.classList.add('pending-order-search__line-item--no-media');
        }

        if (titleLinkNode) {
          if (productUrl) {
            titleLinkNode.href = productUrl;

            if (itemLinkNode) {
              itemLinkNode.href = productUrl;
            }
          } else {
            titleLinkNode.removeAttribute('href');
            titleLinkNode.setAttribute('aria-disabled', 'true');
            titleLinkNode.style.pointerEvents = 'none';

            if (itemLinkNode) {
              itemLinkNode.removeAttribute('href');
              itemLinkNode.setAttribute('aria-disabled', 'true');
              itemLinkNode.style.pointerEvents = 'none';
            }
          }
        }

        list.appendChild(itemNode);
      });

      fragment.appendChild(list);
      return fragment;
    }

    function buildOrderNode(order, index) {
      var orderNode = orderTemplate.content.firstElementChild.cloneNode(true);
      var eyebrowNode = orderNode.querySelector('[data-order-eyebrow]');
      var activeBadgeNode = orderNode.querySelector('[data-order-active-badge]');
      var titleNode = orderNode.querySelector('[data-order-title]');
      var summaryNode = orderNode.querySelector('[data-order-summary]');
      var legacyHeadingNode = orderNode.querySelector('[data-order-heading]');
      var lineItemsNode = orderNode.querySelector('[data-order-line-items]');
      var selectOrderButton = orderNode.querySelector('[data-select-order-button]');
      var checkoutButton = orderNode.querySelector('[data-checkout-button]');
      var cardEyebrow = config.resultHeading || 'Live sale order';
      var isActiveOrder = state.activeDraftOrderId && state.activeDraftOrderId === order.id;
      var hasMultipleOrders = state.currentOrders.length > 1;

      if (eyebrowNode) {
        eyebrowNode.textContent = cardEyebrow;
      }

      if (isActiveOrder) {
        orderNode.classList.add('is-active');
      }

      if (activeBadgeNode && isActiveOrder) {
        activeBadgeNode.style.display = 'inline-flex';
      }

      if (titleNode) {
        titleNode.textContent = getOrderDisplayName(order, textConfig);
      } else if (legacyHeadingNode) {
        legacyHeadingNode.textContent = getOrderDisplayName(order, textConfig);
      }

      if (summaryNode) {
        summaryNode.textContent = getOrderSummary(order, textConfig);
      }

      lineItemsNode.appendChild(buildLineItemsFragment(order));

      if (selectOrderButton) {
        selectOrderButton.dataset.orderIndex = String(index);
        selectOrderButton.style.display = hasMultipleOrders ? 'inline-flex' : 'none';
        selectOrderButton.textContent = isActiveOrder
          ? getTextValue(
              'activeSelectButtonText',
              getTextValue('activeBadgeText', 'Active while shopping')
            )
          : getTextValue('selectOrderButtonText', 'Use this order while shopping');

        if (isActiveOrder) {
          selectOrderButton.classList.add('is-active');
        }
      }

      if (checkoutButton) {
        checkoutButton.dataset.orderIndex = String(index);
        checkoutButton.textContent = getTextValue('checkoutButtonText', 'Add to Cart');
      }

      return orderNode;
    }

    function bindCheckoutButtons() {
      var buttons = resultElement.querySelectorAll('[data-checkout-button][data-order-index]');

      Array.prototype.forEach.call(buttons, function(button) {
        button.addEventListener('click', function(event) {
          event.preventDefault();

          var orderIndex = Number(button.getAttribute('data-order-index'));
          var order = state.currentOrders[orderIndex];

          proceedToCart(order);
        });
      });
    }

    function bindSelectOrderButtons() {
      var buttons = resultElement.querySelectorAll('[data-select-order-button][data-order-index]');

      Array.prototype.forEach.call(buttons, function(button) {
        button.addEventListener('click', function(event) {
          event.preventDefault();

          var orderIndex = Number(button.getAttribute('data-order-index'));
          var order = state.currentOrders[orderIndex];

          if (!order) {
            return;
          }

          saveCurrentOrderContext(order);
          renderOrders();
          var successTemplate = getTextValue(
            'selectOrderSuccessText',
            'Add your Live Sale items to your cart while you shop.'
          );
          showMessage(
            'success',
            '<p style="margin:0;">' +
              formatTemplate(successTemplate, {
                order_name: escapeHtml(getOrderDisplayName(order, textConfig))
              }) +
              '</p>'
          );
        });
      });
    }

    function bindExtraProductButtons() {
      var buttons = resultElement.querySelectorAll('[data-extra-product-toggle]');

      Array.prototype.forEach.call(buttons, function(button) {
        button.addEventListener('click', function(event) {
          event.preventDefault();

          var variantId = button.getAttribute('data-variant-id');
          var quantity = Number(button.getAttribute('data-quantity')) || 1;
          var existingIndex = state.selectedExtras.findIndex(function(item) {
            return item.variantId === variantId;
          });

          if (existingIndex >= 0) {
            state.selectedExtras.splice(existingIndex, 1);
            button.textContent = getTextValue('extraProductButtonText', 'Add this item');
            button.style.background = '#000';
            return;
          }

          state.selectedExtras.push({
            variantId: variantId,
            quantity: quantity
          });
          button.textContent = getTextValue('extraProductAddedText', 'Added');
          button.style.background = '#2e7d32';
        });
      });
    }

    function buildMerchandisingHtml() {
      if (!merchElement) {
        return '';
      }

      return merchElement.innerHTML;
    }

    function renderOrders() {
      if (!state.currentOrders.length) {
        clearResults();
        return;
      }

      var fragment = document.createDocumentFragment();

      state.currentOrders.forEach(function(order, index) {
        fragment.appendChild(buildOrderNode(order, index));
      });

      clearResults();
      resultElement.appendChild(fragment);
      resultElement.insertAdjacentHTML('beforeend', buildMerchandisingHtml());
      bindSelectOrderButtons();
      bindCheckoutButtons();
      bindExtraProductButtons();
    }

    async function addSelectedExtrasToOrder(order) {
      var workerUrl = normalizeWorkerUrl(config.workerUrl);

      if (!state.selectedExtras.length) {
        return order.invoiceUrl;
      }

      if (!workerUrl) {
        throw new Error(getTextValue('workerUrlMissingText', 'Worker URL is not configured in this section yet.'));
      }

      var response = await fetch(workerUrl + '/draft-orders/' + encodeURIComponent(order.id) + '/add-items', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Worker-Secret': config.workerSecret || ''
        },
        body: JSON.stringify({
          items: state.selectedExtras
        })
      });

      var data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(
          data && data.message
            ? data.message
            : getTextValue('addItemsErrorText', 'Unable to add the selected items to your draft order.')
        );
      }

      return data.invoiceUrl || order.invoiceUrl;
    }

    async function proceedToCart(order) {
      if (!order || !order.id) {
        return;
      }

      if (state.isSubmittingCheckout) {
        return;
      }

      state.isSubmittingCheckout = true;
      saveCurrentOrderContext(order);

      try {
        await addSelectedExtrasToOrder(order);
        state.selectedExtras = [];
        renderOrders();
        showMessage(
          'success',
          '<p style="margin:0;">' +
            escapeHtml(getOrderDisplayName(order, textConfig)) +
            ' was added to your cart context.' +
            '</p>'
        );
        openCartForActiveOrder();
      } catch (error) {
        showMessage(
          'error',
          '<p style="margin:0;"><strong>Error:</strong> ' +
            escapeHtml(
              error.message ||
              getTextValue('checkoutPrepareErrorText', 'Unable to prepare checkout right now.')
            ) +
            '</p>'
        );
      } finally {
        state.isSubmittingCheckout = false;
      }
    }

    async function searchDraftOrders() {
      var email = (emailInput.value || '').trim();
      var workerUrl = normalizeWorkerUrl(config.workerUrl);
      var currentRequestId;

      if (!email) {
        showMessage(
          'error',
          '<p style="margin:0;">' +
            getTextValue('emailRequiredText', 'Please enter your email address.') +
            '</p>'
        );
        clearResults();
        return;
      }

      if (!workerUrl) {
        showMessage(
          'error',
          '<p style="margin:0;">' +
            getTextValue('workerUrlMissingText', 'Worker URL is not configured in this section yet.') +
            '</p>'
        );
        clearResults();
        return;
      }

      clearMessage();
      clearResults();
      state.currentOrders = [];
      state.selectedExtras = [];
      state.currentEmail = email;
      clearSavedOrderState();
      resetRecommendations();
      currentRequestId = state.searchRequestId + 1;
      state.searchRequestId = currentRequestId;

      var savedContext = draftOrderFlow && draftOrderFlow.readContext ? draftOrderFlow.readContext() : null;

      if (savedContext && savedContext.email && savedContext.email !== email) {
        renderSavedOrderState(null);
      }

      setSearching(true);

      try {
        var response = await fetch(workerUrl + '/draft-orders?email=' + encodeURIComponent(email), {
          method: 'GET',
          headers: {
            'X-Worker-Secret': config.workerSecret || ''
          }
        });

        var data = await response.json();

        if (currentRequestId !== state.searchRequestId) {
          return;
        }

        if (!response.ok) {
          throw new Error(data && data.message ? data.message : 'Unable to load draft orders.');
        }

        state.currentOrders = Array.isArray(data.orders) ? data.orders : [];
        state.selectedExtras = [];

        if (!state.currentOrders.length) {
          clearSavedOrderState();
          var noOrdersTemplate = getTextValue(
            'noOrdersFoundText',
            'No open draft orders were found for <strong>[email]</strong>.'
          );
          showMessage(
            'success',
            '<p style="margin:0;">' + formatTemplate(noOrdersTemplate, { email: escapeHtml(email) }) + '</p>'
          );
          clearResults();
          return;
        }

        if (state.currentOrders.length > 1) {
        var multiTemplate = getTextValue(
          'multipleOrdersFoundText',
          '<strong>Multiple live sale orders found.</strong> Tap "<em>[select_button]</em>" on the order you want to keep active while you continue browsing the site.'
        );
          showMessage(
            'info',
            '<p style="margin:0;">' +
              formatTemplate(multiTemplate, {
                select_button: getTextValue('selectOrderButtonText', 'Use this order while shopping')
              }) +
              '</p>'
          );
        } else {
          state.activeDraftOrderId = '';
          renderSavedOrderState(null);
          var singleTemplate = getTextValue(
            'singleOrderFoundText',
            'Order found. Click "[checkout_button]" to activate it.'
          );
          showMessage(
            'info',
            '<p style="margin:0;">' +
              formatTemplate(singleTemplate, {
                checkout_button: getTextValue('checkoutButtonText', 'Add to Cart')
              }) +
              '</p>'
          );
        }

        renderOrders();
      } catch (error) {
        if (currentRequestId !== state.searchRequestId) {
          return;
        }

      showMessage(
        'error',
        '<p style="margin:0;"><strong>Error:</strong> ' +
          escapeHtml(
            error.message ||
            getTextValue('loadOrdersErrorText', 'Unable to load draft orders.')
          ) +
          '</p>'
      );
      resetRecommendations();
      clearResults();
      } finally {
        if (currentRequestId === state.searchRequestId) {
          setSearching(false);
        }
      }
    }

    searchButton.addEventListener('click', function(event) {
      event.preventDefault();
      searchDraftOrders();
    });

    emailInput.addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        searchDraftOrders();
      }
    });

    if (clearSavedButton) {
      clearSavedButton.textContent = 'Remove from cart';
      clearSavedButton.addEventListener('click', function(event) {
        event.preventDefault();
        clearSavedOrderState();
        showMessage(
          'success',
          '<p style="margin:0;">' +
            getTextValue('clearSavedSuccessText', 'Saved live sale order cleared.') +
            '</p>'
        );
      });
    }

    var params = new URLSearchParams(window.location.search);
    var emailParam = (params.get('email') || '').trim();
    var orderParam = (params.get('order') || '').trim();

    if (emailParam) {
      emailInput.value = emailParam;
      searchDraftOrders();
    } else if (orderParam) {
      showMessage(
        'error',
        '<p style="margin:0;">' +
          getTextValue('missingEmailParamText', 'This direct link needs an email parameter to load the draft order automatically.') +
          '</p>'
      );
    } else if (draftOrderFlow) {
      renderSavedOrderState(draftOrderFlow.readContext());
    }

    $section.data('pending-order-search-handlers', {
      searchButtonHandler: searchDraftOrders
    });

    resetRecommendations();
    window.pendingOrderSearchState = window.pendingOrderSearchState || {};
    window.pendingOrderSearchState[config.section_id] = state;
  }

  function destroySection($section) {
    if (!$section || !$section.length) {
      return;
    }

    $section.removeData('pending-order-search-initialized');
    $section.removeData('pending-order-search-handlers');
  }

  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.jsPendingOrderSearch = {
    init: function($section) {
      var config = window.PXUTheme.getSectionData($section);
      initializeSection($section, config);
    },
    unload: function($section) {
      destroySection($section);
    }
  };

  if (document.readyState !== 'loading') {
    $('.jsPendingOrderSearch').each(function() {
      window.PXUTheme.jsPendingOrderSearch.init($(this));
    });
  }
})();
